<!--
 * @Author: van
 * @Date: 2021-09-30 12:18:28
 * @LastEditors: van
 * @LastEditTime: 2021-10-06 16:32:51
-->
<template>
  <el-row>
    <el-col :span="24"
            class="tagsContainer">
      <el-tag v-for="(item,index) in tags"
              :key="index"
              size="small"
              :closable="!disabled"
              @close="closeItem(index)"
              style="margin-right:2px">
        {{ item }}
      </el-tag>
    </el-col>
    <el-col :span="24"
            v-show="!disabled">
      <el-input clearable
                :placeholder="`${$t('goodsList.add.inputPlaceholder')}${title}${$i18n.locale=='zh'?'，单击回车生成数据':',Click Enter to generate data'}`"
                size="small"
                v-model.trim="inputValue"
                @blur="tagsEnter"
                @keyup.enter.native="tagsEnter">
      </el-input>
    </el-col>
  </el-row>
</template>
<script>
export default {
    data() {
        return {
            inputValue: "",
            tags: [],
        };
    },
    methods: {
        closeItem(index) {
            this.tags.splice(index, 1);
            this.$emit("update:tagsList", this.tags);
        },
        tagsEnter() {
            if (this.inputValue) {
                this.tags.push(this.inputValue);
            }
            this.inputValue = "";
            this.$emit("update:tagsList", this.tags);
        },
    },
    props: {
        tagsList: Array,
        title: String,
        visible: Boolean,
        disabled: {
            type: Boolean,
            default: () => {
                return false;
            },
        },
    },
    watch: {
        visible: {
            handler(newValue) {
                if (!newValue) {
                    this.inputValue = "";
                }
            },
            immediate: false,
            deep: true,
        },
        tagsList:{
            handler(newValue) {
                console.log(newValue)
                if (newValue) {
                    this.tags = newValue;
                }
            },
            deep: true,
            immediate: true,
        }
    },
};
</script>
<style lang="scss">
.tagsContainer {
    text-align: left;
}
</style>